/**
 * @generated SignedSource<<a29b2bba912cf0d517be228de8194239>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateStudySessionsInput = {
  clientMutationId?: string | null;
  eventsType: string;
  sessions: ReadonlyArray<StudySessionInput | null>;
  studyId: string;
};
export type StudySessionInput = {
  availabilitySlots?: ReadonlyArray<AvailabilitySlotInput | null> | null;
  duration?: number | null;
  id?: string | null;
  name?: string | null;
};
export type AvailabilitySlotInput = {
  availabilityBuffer?: number | null;
  duration?: number | null;
  end?: any | null;
  id?: string | null;
  inPerson?: boolean | null;
  interviewer?: string | null;
  meetingDetails?: string | null;
  meetingLink?: string | null;
  meetingLocation?: string | null;
  placesLimit?: number | null;
  start?: any | null;
};
export type SessionsForm_updateStudySessions_Mutation$variables = {
  input: UpdateStudySessionsInput;
};
export type SessionsForm_updateStudySessions_Mutation$data = {
  readonly updateStudySessions: {
    readonly study: {
      readonly " $fragmentSpreads": FragmentRefs<"SessionsForm_study">;
    } | null;
  } | null;
};
export type SessionsForm_updateStudySessions_Mutation = {
  response: SessionsForm_updateStudySessions_Mutation$data;
  variables: SessionsForm_updateStudySessions_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventsType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countOfBookedSlots",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inPerson",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLink",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLocation",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingDetails",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placesLimit",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "InterviewerNode",
  "kind": "LinkedField",
  "name": "interviewer",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionsForm_updateStudySessions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStudySessionsPayload",
        "kind": "LinkedField",
        "name": "updateStudySessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SessionsForm_study"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SessionsForm_updateStudySessions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStudySessionsPayload",
        "kind": "LinkedField",
        "name": "updateStudySessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canHaveMultipleSessions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudySessionNodeConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudySessionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudySessionNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                            "kind": "LinkedField",
                            "name": "availabilitySlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudyAvailabilitySlotNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availabilityBuffer",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": "_value",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "meetingDetails",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StudySessionNode",
                                        "kind": "LinkedField",
                                        "name": "session",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StudyNode",
                                            "kind": "LinkedField",
                                            "name": "study",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v3/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StudySessionNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "sessions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StudySessionNodeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "StudySessionNode",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v2/*: any*/),
                                                          (v4/*: any*/),
                                                          (v5/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "availabilitySlots",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "StudyAvailabilitySlotNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      (v7/*: any*/),
                                                                      (v8/*: any*/),
                                                                      (v5/*: any*/),
                                                                      (v14/*: any*/),
                                                                      (v9/*: any*/),
                                                                      (v12/*: any*/),
                                                                      (v10/*: any*/),
                                                                      (v11/*: any*/),
                                                                      (v13/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voxpopmeRecorderEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0131954af9326f654c6a2ee7f841c1e9",
    "id": null,
    "metadata": {},
    "name": "SessionsForm_updateStudySessions_Mutation",
    "operationKind": "mutation",
    "text": "mutation SessionsForm_updateStudySessions_Mutation(\n  $input: UpdateStudySessionsInput!\n) {\n  updateStudySessions(input: $input) {\n    study {\n      ...SessionsForm_study\n      id\n    }\n  }\n}\n\nfragment InputSlotDetails_slot on StudyAvailabilitySlotNode {\n  id\n  _value: meetingDetails\n  session {\n    study {\n      id\n      eventsType\n      sessions {\n        edges {\n          node {\n            id\n            name\n            duration\n            availabilitySlots {\n              edges {\n                node {\n                  id\n                  start\n                  end\n                  duration\n                  interviewer {\n                    email\n                    id\n                  }\n                  inPerson\n                  meetingDetails\n                  meetingLink\n                  meetingLocation\n                  placesLimit\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment SessionsForm_FocusGroupSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_InterviewSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_study on StudyNode {\n  id\n  dId\n  type\n  eventsType\n  status\n  approvedCount\n  tenant {\n    vpmAccountId\n    id\n  }\n  canHaveMultipleSessions\n  sessions {\n    edges {\n      node {\n        id\n        name\n        duration\n        countOfBookedSlots\n        availabilitySlots {\n          edges {\n            node {\n              id\n              start\n              end\n              availabilityBuffer\n              duration\n              inPerson\n              meetingLink\n              meetingLocation\n              meetingDetails\n              placesLimit\n              interviewer {\n                email\n                id\n              }\n              ...SessionsForm_FocusGroupSlotEditor_slot\n              ...SessionsForm_InterviewSlotEditor_slot\n            }\n          }\n        }\n      }\n    }\n  }\n  voxpopmeRecorderEnabled\n}\n"
  }
};
})();

(node as any).hash = "d8702eda582a4aa142d334cf59df3f87";

export default node;
